import { forwardRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {
  AppContainer,
  ContactForm,
  ContactFormFooter,
  ContactSectionHeader,
  ContactFormInput,
  ContactFormTextArea,
  PageBody,
  SocialButtonTwitter,
  SocialButtonLinkedin,
  SocialButtonInstagram,
  SocialButtonGithub,
  SocialButtonFacebook,
  ContactSocialButtons,
  ContactLine,
  ContactPage,
  ContactSocial,
  ContactDownloadButton,
  PageHeadingText,
  FormErrorText,
} from '../components/styled';

import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { sendEmail } from '../api';
import resume from '../assets/resume.pdf';

const ContactSocialSection = () => {
  const handleResumeDownload = () => {
    const link = document.createElement('a');
    link.href = resume;
    link.setAttribute('download', `jmoore_resume.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  return (
    <ContactSocial>
      <ContactSectionHeader>
        <PageHeadingText>Contact Me</PageHeadingText>
      </ContactSectionHeader>
      <ContactLine>
        <FontAwesomeIcon icon={faPaperPlane} />
        <p>jamal.moore26@gmail.com</p>
      </ContactLine>
      <ContactLine>
        <FontAwesomeIcon icon={faGlobe} />
        <p>
          <a href="/">www.jamalmoore.me</a>
        </p>
      </ContactLine>
      <ContactSocialButtons>
        <SocialButtonTwitter>
          <a style={{ color: 'white' }} rel="noreferrer" href="https://twitter.com/jm4l1">
            <TwitterIcon />
          </a>
        </SocialButtonTwitter>
        <SocialButtonLinkedin>
          <a
            style={{ color: 'white' }}
            rel="noreferrer"
            href="https://www.linkedin.com/in/jamalmoore/"
          >
            <LinkedIcon />
          </a>
        </SocialButtonLinkedin>
        <SocialButtonInstagram>
          <a style={{ color: 'white' }} rel="noreferrer" href="https://www.instagram.com/jm4l1/">
            <InstagramIcon />
          </a>
        </SocialButtonInstagram>
        <SocialButtonGithub>
          <a style={{ color: 'white' }} rel="noreferrer" href="https://github.com/jm4l1">
            <GitHubIcon />
          </a>
        </SocialButtonGithub>
        <SocialButtonFacebook>
          <a
            style={{ color: 'white' }}
            rel="noreferrer"
            href="https://www.facebook.com/jamal.moore.5855"
          >
            <FacebookIcon />
          </a>
        </SocialButtonFacebook>
      </ContactSocialButtons>
      <ContactDownloadButton onClick={handleResumeDownload}>Download Resume</ContactDownloadButton>
    </ContactSocial>
  );
};
const ContactFormSection = () => {
  const [name, setName] = useState('');
  const [onBehalf, setOnBehalf] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [includeSender, setIncludeSender] = useState(false);
  const [formError, setFormError] = useState('');

  async function handleFormSend() {
    setFormError('');

    if (!onBehalf || !message || !subject) {
      setFormError('Enter all required values');
      return;
    }
    //eslint-disable-next-line
    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!onBehalf.match(mailFormat)) {
      setFormError('Invalid email address');
      document.querySelector('#form-email').classList.add('error');
      return;
    }
    const details = {
      name,
      on_behalf: onBehalf,
      recipient: process.env.REACT_APP_email_form_recipient,
      sender: process.env.REACT_APP_email_form_sender,
      subject,
      message,
      email_type: process.env.REACT_APP_email_form_type,
    };
    const email_sent = await sendEmail(details, includeSender);

    setName('');
    setOnBehalf('');
    setSubject('');
    setMessage('');
    setIncludeSender(false);
    setFormError('');

    if (!email_sent) {
      alert('Unable to send message');
    } else {
      alert('Message sent');
    }
  }

  return (
    <ContactForm>
      <Form.Group>
        <ContactFormInput
          className={formError && !name && 'error'}
          id="form-name"
          type="text"
          placeholder="Name..."
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <ContactFormInput
          className={formError && !onBehalf && 'error'}
          id="form-email"
          type="email"
          placeholder="Email..."
          value={onBehalf}
          onChange={e => setOnBehalf(e.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <ContactFormInput
          className={formError && !subject && 'error'}
          id="form-subject"
          type="text"
          placeholder="Subject"
          value={subject}
          onChange={e => setSubject(e.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <ContactFormTextArea
          className={formError && !message && 'error'}
          id="form-message"
          rows="10"
          as="textarea"
          placeholder="Type Message Here..."
          value={message}
          onChange={e => setMessage(e.target.value)}
        />
      </Form.Group>
      <ContactFormFooter>
        <Form.Check label="Send copy to my email" />
        <Button onClick={handleFormSend}>Send</Button>
      </ContactFormFooter>
      <FormErrorText>
        <Form.Text>{formError}</Form.Text>
      </FormErrorText>
    </ContactForm>
  );
};
export const Contact = forwardRef(({ height }, ref) => {
  return (
    <AppContainer ref={ref} height={height} id="contact">
      <ContactPage>
        <PageBody>
          <ContactSocialSection />
          <ContactFormSection />
        </PageBody>
      </ContactPage>
    </AppContainer>
  );
});
